module.exports = "<a seedelement class=\"lui-interactive lui-hover-only\"><slot></slot></a>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-breadcrumb/theme/lui-breadcrumbitem.html
// module id = 175
// module chunks = 0 1 11